"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listaEstadoCivil = exports.EEstadoCivil = void 0;
var EEstadoCivil;
(function (EEstadoCivil) {
    EEstadoCivil["N\u00E3o Informado"] = "0";
    EEstadoCivil["Solteiro(a)"] = "1";
    EEstadoCivil["Casado(a)"] = "2";
    EEstadoCivil["Desquitado(a)"] = "3";
    EEstadoCivil["Separado(a)"] = "4";
    EEstadoCivil["Vi\u00FAvo(a)"] = "5";
    EEstadoCivil["Divorciado(a)"] = "6";
    EEstadoCivil["Amasiado(a)"] = "7";
    EEstadoCivil["Uni\u00E3o Est\u00E1vel"] = "8";
    EEstadoCivil["Outros"] = "9";
})(EEstadoCivil = exports.EEstadoCivil || (exports.EEstadoCivil = {}));
exports.listaEstadoCivil = [
    'Não Informado',
    'Solteiro(a)',
    'Casado(a)',
    'Desquitado(a)',
    'Separado(a)',
    'Viúvo(a)',
    'Divorciado(a)',
    'Amasiado(a)',
    'União Estável',
    'Outros',
];
